import { render, staticRenderFns } from "./CameraDeviceTab.vue?vue&type=template&id=64001de6&scoped=true&"
import script from "./CameraDeviceTab.vue?vue&type=script&lang=js&"
export * from "./CameraDeviceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001de6",
  null
  
)

export default component.exports